import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import Header from "../header";
import Footer from "../footer";
import moment from "moment";
import { leaveapply } from "../../service/dashboard";
import { toast } from "react-toastify";

const ApplyLeave = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [ltype, setLType] = useState("");
    const [ptype, setPType] = useState("");
    const [ldays, setLDays] = useState("");
    const [fdate, setFDate] = useState("");
    const [tdate, setTDate] = useState("");
    const [lreason, setLReason] = useState("");
    const [lsubmit, setLSubmit] = useState(false);

    useEffect(() => {
        setFDate(moment(new Date()).format("YYYY-MM-DD"));
        setTDate(moment(new Date()).format("YYYY-MM-DD"));
    }, []);
  const [errormsg, setErrMsg] = useState("");

    function leavesubmit(e) {
        e.preventDefault();
        setLSubmit(true);
        if (
            ltype !== "" &&
            ptype !== "" &&
            ldays !== "" &&
            fdate !== "" &&
            tdate !== "" &&
            lreason !== ""
        ) {

            const temp = new FormData();
            temp.append("academy_id", localStorage.getItem("academy"));
            temp.append("leave_permission", ltype);
            temp.append("leave_type", ptype);
            temp.append("total_leave", ldays);
            temp.append("from_date", fdate);
            temp.append("to_date", tdate);
            temp.append("reason", lreason);
            temp.append("id", id ? id : "");
            leaveapply(temp).then((res) => {
                if (res.status === true) {
                    setLSubmit(false);
                    toast.success(res.message);
                    navigate("/leavedashboard");
                } else {
                    setErrMsg(res.message);
                }
            });
        }
    }
    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />
                <div className="moreheading">
                    <Row className="row-sm">
                        <Col xs={6} className="text-left align-self-end">
                            <h4 className="morehead-text">Apply Leave</h4>
                        </Col>
                        <Col xs={6} className="text-right align-self-end">
                            <Link to={"/leavedashboard"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>
                    </Row>
                </div>
                <div className="leave-container">
                    <div className="row">
                        <div className="col-lg-3 col-md-3">
                            <div className="formapply">
                                <label className="form-label fw-bold">Type  <span className="text-danger"> *</span></label>
                                <select
                                    className="form-control"
                                    onChange={(e) => setLType(e.target.value)}
                                    value={ltype}
                                >
                                    <option value="" disabled>
                                        Select Type
                                    </option>
                                    <option value="Leave">Leave</option>
                                    <option value="Permission">Permission</option>
                                </select>
                                {lsubmit && ltype === "" && (
                                    <span className="text-danger">Please Select Type</span>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3">
                            <div className="formapply">

                                <label className="form-label fw-bold">Leave/Permission Type  <span className="text-danger"> *</span></label>
                                <select
                                    className="form-control"
                                    onChange={(e) => setPType(e.target.value)}
                                    value={ptype}
                                >
                                    <option value="" disabled>
                                        Select Leave/Permission Type
                                    </option>
                                    <option value="Sick">Sick</option>
                                    <option value="Casual">Casual</option>
                                    <option value="Personal">Personal</option>
                                </select>
                                {lsubmit && ptype === "" && (
                                    <span className="text-danger">
                                        Please Select Leave/Permission Type
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3">
                            <div className="formapply">

                                <label className="form-label fw-bold">Total Leave Days/Permission (In Hrs) <span className="text-danger"> *</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Total Leave Days/Permission (In Hrs)"
                                    onChange={(e) => setLDays(e.target.value)}
                                    value={ldays}
                                />
                                {lsubmit && ldays === "" && (
                                    <span className="text-danger">
                                        Please Enter Total Leave Days/Permission (In Hrs)
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3">
                            <div className="formapply">

                                <label className="form-label fw-bold">From Date <span className="text-danger"> *</span></label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder="Enter From Date"
                                    onChange={(e) => setFDate(e.target.value)}
                                    value={fdate}
                                />
                                {lsubmit && fdate === "" && (
                                    <span className="text-danger">
                                        Please Enter From Date
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3">
                            <div className="formapply">

                                <label className="form-label fw-bold">To Date <span className="text-danger"> *</span></label>
                                <input
                                    type="date"
                                    className="form-control"
                                    placeholder="Enter To Date"
                                    onChange={(e) => setTDate(e.target.value)}
                                    value={tdate}
                                />
                                {lsubmit && tdate === "" && (
                                    <span className="text-danger">
                                        Please Enter To Date
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-3">
                            <div className="formapply">

                                <label className="form-label fw-bold">Reason <span className="text-danger"> *</span></label>
                                <textarea
                                    className="form-control"
                                    name="example-textarea-input"
                                    rows={4}
                                    placeholder="Enter Reason"
                                    onChange={(e) => setLReason(e.target.value)}
                                    value={lreason}
                                />
                                {lsubmit && lreason === "" && (
                                    <span className="text-danger">
                                        Please Enter Reason
                                    </span>
                                )}
                            </div>
                        </div>
                    </div>
                    {errormsg && <span className="text-danger">{errormsg}</span>}
                    <div className="text-right mb-5">
                        <button className="btn btn-success me-2" onClick={leavesubmit}>
                            Submit
                        </button>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default ApplyLeave;
